import apiHandler from "../../../../api/core/apiHandler";

const PayablePaymentApi = apiHandler("payable/payments");

export default PayablePaymentApi;